import { Schema } from 'normalizr';

export const episodeSchema = new Schema('episode', { idAttribute: 'id' });
